
import './App.css';

import HomePage from './pages/HomePage/HomePage';
import CollectionsPage from './pages/CollectionsPage/CollectionsPage';
import CollectionItemPage from './pages/CollectionItemPage/CollectionItemPage';
import FAQPage from './pages/FAQPage/FAQPage';
import ItemDetailsPage from './pages/ItemDetailsPage/ItemDetailsPage';
import UploadNFTPage from './pages/UploadNFTPage/UploadNFTPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage/PrivacyPolicyPage';

import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import NavBar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import SideBar from './components/Sidebar/Sidebar';
import ProfilePage from './pages/ProfilePage/ProfilePage';
import ConnectWalletPage from './pages/ConnectWalletPage/ConnectWalletPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import ActivityStatsPage from './pages/ActivityStatsPage/ActivityStatsPage';
import RankingStatsPage from './pages/RankingStatsPage/RankingStatsPage';
import AuctionPage from './pages/AuctionPage/AuctionPage';
import LaunchpadPage from './pages/LaunchpadPage/LaunchpadPage';
import MemberPage from './pages/MemberPage/MemberPage';
import ScrollToTop from './Hooks/ScrollToTop';

function App() {
  return (
    <div className="dark:bg-black min-h-[100vh] ">
      <Router>   
        <NavBar />
          <SideBar />
          <ScrollToTop />
          <Routes> 
            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/collections" element={<CollectionsPage />} />
            <Route path = '/collection/:id' element = {<CollectionItemPage/>} />
            <Route path = '/itemdetails/:id' element = {<ItemDetailsPage />} />
            <Route path = '/faq' element = {<FAQPage/>} />
            <Route path = '/userprofile' element = {<ProfilePage />} />
            <Route path = '/uploadnft' element = {<UploadNFTPage />} />
            <Route path = '/privacypolicy' element = {<PrivacyPolicyPage />} />
            <Route path = '/connectwallet' element = {<ConnectWalletPage />} />
            <Route path = '/activity' element = {<ActivityStatsPage />} />
            <Route path = '/rankings' element = {<RankingStatsPage />} />
            <Route path = '/auction/:id' element = {<AuctionPage />} />
            <Route path = '/launchpad/:id' element = {<LaunchpadPage />} />
            <Route path = '/member/:id' element = {<MemberPage/>} />
            <Route path="*" element = {<NotFoundPage />} /> 
          </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
